import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { SectionDefinition } from '../../../components/Sections/Sections.types'

export enum TrailFeatureSectionIds {
  general = 'general',
}

/**
 * @description Sections shared by the Trail Feature detail page and edit form, in display order.
 */
export const trailFeatureSections: SectionDefinition[] = [
  {
    id: TrailFeatureSectionIds.general,
    title: 'General',
    description: 'Feature name and visibility.',
    icon: InfoOutlinedIcon,
  },
]
